import {Outlet} from 'react-router-dom';

import Footer from '@common/layout/Footer';
import Header from '@common/layout/Header';
import HeaderMenu from '@common/components/HeaderMenu';

const ReferentialLayout = () => (
  <div className="w-full h-full min-h-screen flex flex-col relative pb-10">
    <Header>
      <HeaderMenu />
    </Header>
    <Outlet />
    <Footer />
  </div>
);

export default ReferentialLayout;
